<template>
  <div>
    <div v-if="loadingServices">
      <v-row class="text-center" align="center" justify="center">
        <v-progress-circular
          :indeterminate="true"
          :rotate="0"
          :size="32"
          :width="4"
          color="light-blue"
        ></v-progress-circular>
      </v-row>
      <v-row class="text-center" align="center" justify="center">
        Caricamento in corso....
      </v-row>
    </div>

    <div v-if="!loadingServices">
      <v-row
        v-if="!this.$store.state.editing"
        class="form-title"
        align="center"
        justify="center"
        ><h2 class="header-title-h2">
          L'aspetto del suo sito è stato deciso.
        </h2></v-row
      >
      <v-row
        v-if="!this.$store.state.editing"
        class="form-title"
        align="center"
        justify="center"
      >
        <h3>
          Adesso selezioni i servizi che offre ai suoi clienti.<br />Le
          ricordiamo che ogni configurazione può essere modificata in un momento
          successivo alla creazione.
        </h3></v-row
      >

      <v-row dense align="center" justify="center">
        <v-btn
          v-scroll-to="'#card_' + index"
          class="ml-1 mr-1"
          color="primary"
          v-for="(n, index) in services"
          :key="n.id + '_btn'"
          >{{ n.category_name }}</v-btn
        >
      </v-row>

      <div :id="'card_' + index" v-for="(n, index) in services" :key="n.id">
        <div style="height:20px"></div>
        <h3 class="font-weight-bold ma-5">{{ n.category_name }}</h3>
        <v-card class="mx-auto ma-2" max-width="800" outlined>
          <v-card-text
            v-for="s in n.categories"
            :key="s.id"
            class="service-card"
          >
            <v-row
              class="text-left service-row"
              align="center"
              justify="center"
            >
              <v-col>{{ s.name }}</v-col
              ><v-col style="max-width: 40px"
                ><v-checkbox
                  v-model="s.checked"
                  class="service-check text-right"
                  hide-details
              /></v-col>
            </v-row>
            <v-row
              dense
              class="text-left service-description"
              align="center"
              justify="center"
            >
              <v-col>{{ s.description }} </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div class="form-spacer" />

    <v-row class="text-center" align="center" justify="center">
      <v-btn
        class="ml-2"
        v-if="!servicesSelected && !this.$store.state.editing"
        @click="goBack()"
        color="primary"
        >Indietro</v-btn
      >
      <v-btn
        class="ml-2"
        v-if="!servicesSelected && !this.$store.state.editing"
        @click="selectServices($event)"
        color="primary"
      >
        Passo successivo
      </v-btn>

      <v-btn
        class="ml-2"
        v-if="!servicesSelected && this.$store.state.editing"
        @click="editServices($event)"
        color="primary"
      >
        Modifica servizi
      </v-btn>

      <v-progress-circular
        v-if="servicesSelected"
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>
    <div class="form-spacer" />
  </div>
</template>

<style scoped>
.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.service-row {
  background-color: #b5c8e1;
  font-size: 18px;
  margin-left: 2px;
  margin-right: 2px;
}

.service-description {
  background-color: #fafafa;
  font-size: 14px;
  margin-left: 2px;
  margin-right: 2px;
  color: #aaaaaa;
}

.service-card {
  padding: 5px;
}

.form-spacer {
  height: 30px;
}

.service-check {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>

<script>
import services from "../../apis/services";
import store from "../../store/index";

export default {
  data() {
    return {
      loadingServices: true,
      servicesSelected: false,
      services: [],
    };
  },

  mounted() {
    this.loadingServices = false;
    this.loadServices()
      .then((res) => {
        this.services = res.services;
        let services_list = this.$store.state.wizard.meta
          ? this.$store.state.wizard.meta.services
          : null;
        if (services_list) services_list = services_list.split(",").map(Number);
        for (let n in this.services) {
          let service = this.services[n];
          for (let c in service.categories) {
            let category = service.categories[c];
            if (services_list && services_list.includes(category.id)) {
              category.checked = true;
            } else category.checked = false;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    getServices() {
      let services_id = [];
      for (let n in this.services) {
        let service = this.services[n];
        for (let c in service.categories) {
          let category = service.categories[c];
          if (category.checked) services_id.push(category.id);
        }
      }
      let services_list = services_id.join(",");
      return services_list;
    },

    loadServices() {
      return services.fetchServices();
    },

    selectServices() {
      this.servicesSelected = true;
      let completedStep = this.$store.state.wizard.completedStep;
      if (completedStep < this.$store.state.wizard.selectedStep)
        completedStep = this.$store.state.wizard.selectedStep;

      store
        .dispatch("setWizardSteps", {
          completedStep: completedStep,
          selectedStep: this.$store.state.wizard.selectedStep + 1,
          meta: {
            services: this.getServices(),
          },
        })
        .then(() => {
          this.servicesSelected = false;
        });
    },

    editServices() {
      this.servicesSelected = true;

      store
        .dispatch("setEditingMeta", {
          meta: {
            services: this.getServices(),
          },
        })
        .then(() => {
          this.$router.push("/");
        });
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },
  },
};
</script>
